<template>
  <div>
    <div class="toolbar-shell">
      <div class="toolbar-accent"></div>
      <v-app-bar
        color="primary"
        elevate-on-scroll
        clipped-left
        app
        class="suspended-toolbar"
        :class="{ 'suspended-toolbar--mini': minivariant }"
      >
        <v-btn @click="changeDrawer" style="margin-left: 0px; margin-right: 8px" text small fab color="white">
          <v-icon>dehaze</v-icon>
        </v-btn>

        <div>
          <span class="text-h6 text-uppercase textDarkPrimary--text font-weight-bold">{{
            this.user && this.user.owner ? this.user.owner.nome : ""
          }}</span>
        </div>

        <v-toolbar-title style="color: white">
          <v-btn v-if="carregandoDadosOwner" :loading="carregandoDadosOwner" depressed text dark> </v-btn>
        </v-toolbar-title>

        <v-spacer></v-spacer>

        <v-menu
          close-on-click
          close-on-content-click
          offset-y
          right
          origin="top right"
          nudge-bottom="8"
          transition="scale-transition"
          width="320"
        >
          <template v-slot:activator="{ on }">
            <v-btn :loading="!!carregandoDadosOwner" depressed text color="white" v-on="on">
              <img src="../../assets/profile-sem-foto.png" width="34" alt="foto do usuário" />

              <div class="d-flex flex-column text-start mx-3">
                <span class="text-caption textDarkTertiary--text font-weight-medium">Bem-vindo(a),</span>
                <span class="text-subtitle-2 mt-n1 textDarkPrimary--text">{{ user ? user.nome : "" }}</span>
              </div>

              <v-icon>mdi-chevron-down</v-icon>
            </v-btn>
          </template>

          <v-card class="pa-3 rounded-lg" elevation="6" max-width="320" width="320">
            <div class="d-flex align-center">
              <v-avatar size="56" class="mr-3">
                <v-icon size="56" color="primary">mdi-account-circle</v-icon>
              </v-avatar>
              <div class="d-flex flex-column">
                <div class="text-h6 font-weight-medium textPrimary--text">{{ user ? user.nome : "" }}</div>
                <div class="textSecondary--text mt-n2">{{ user ? user.login : "" }}</div>
              </div>
            </div>

            <v-divider class="my-3"></v-divider>

            <v-list dense class="py-0">
              <v-list-item class="rounded-lg mb-2" @click="perfil">
                <v-list-item-icon>
                  <v-icon color="indigo">mdi-account</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title class="text-subtitle-1 textPrimary--text">Meu perfil</v-list-item-title>
                  <v-list-item-subtitle class="textSecondary--text">Configurações da conta</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list>

            <v-divider class="my-2"></v-divider>

            <div class="pt-2">
              <v-btn block outlined color="error" @click="logout">
                Sair
                <v-icon right>mdi-logout</v-icon>
              </v-btn>
            </div>
          </v-card>
        </v-menu>
      </v-app-bar>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import COLORS from "@/constants/colors.js";

export default {
  data() {
    return {
      carregandoDadosOwner: false,
      username: "",
      owner: "",
      nome: "",
      items: [
        {
          title: "Perfil",
          icon: "mdi-account",
          color: "blue",
          action: this.perfil,
        },
        {
          title: "Sair",
          icon: "mdi-exit-to-app",
          color: "red",
          action: this.logout,
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      user: "Login/user",
      minivariant: "General/minivariant",
    }),
    COLORS: () => COLORS,
  },
  methods: {
    logout() {
      this.$store.dispatch("Login/logout").then(() => {
        return this.$router.push("/login");
      });
    },
    perfil() {
      if (this.$router.currentRoute.path != "/perfil") {
        this.$router.push("/perfil");
      }
    },

    openRoute(route) {
      if (this.$router.currentRoute.path != route) this.$router.push(route);
    },

    dashboard() {
      if (this.$router.currentRoute.path != "/") {
        this.$router.push("/");
      }
    },

    relProficienciaRede() {
      if (this.$router.currentRoute.path != "/relatorios/proficiencia-da-rede") {
        this.$router.push("/relatorios/proficiencia-da-rede");
      }
    },
    relProficienciaEscola() {
      if (this.$router.currentRoute.path != "/relatorios/proficiencia-da-escola") {
        this.$router.push("/relatorios/proficiencia-da-escola");
      }
    },
    relProficienciaTurma() {
      if (this.$router.currentRoute.path != "/relatorios/proficiencia-da-turma") {
        this.$router.push("/relatorios/proficiencia-da-turma");
      }
    },
    relProficienciaAluno() {
      if (this.$router.currentRoute.path != "/relatorios/proficiencia-do-aluno") {
        this.$router.push("/relatorios/proficiencia-do-aluno");
      }
    },
    relDistribuicaoNiveis() {
      if (this.$router.currentRoute.path != "/relatorios/distribuicao-dos-niveis") {
        this.$router.push("/relatorios/distribuicao-dos-niveis");
      }
    },
    relEscolasQuartil() {
      if (this.$router.currentRoute.path != "/relatorios/Escolas-por-quartil") {
        this.$router.push("/relatorios/Escolas-por-quartil");
      }
    },
    changeDrawer() {
      // In mobile, directly toggle the Drawer via event so it opens immediately
      if (this.$vuetify && this.$vuetify.breakpoint && this.$vuetify.breakpoint.mdAndDown) {
        this.$root.$emit("toggle-mobile-drawer");
        return;
      }

      this.$store.dispatch("General/changeMinivariantStatus");
    },
  },
  created() {
    this.carregandoDadosOwner = true;
    this.$store.dispatch("Login/getUser").then((response) => {
      this.username = response.nome;
      this.owner = response.owner.nome;
      this.carregandoDadosOwner = false;
    });
  },
};
</script>

<style scoped>
.suspended-toolbar {
  position: fixed !important;
  top: 10px !important;
  right: 20px !important;
  left: auto !important;
  /* drawer left(10) + drawer width(240) + gap(21) + toolbar right(20) = 291 */
  width: calc(100% - 291px) !important;
  border-radius: 8px !important;
  margin-bottom: 10px !important;
  transition: width 350ms cubic-bezier(0.25, 0.8, 0.25, 1), left 350ms cubic-bezier(0.25, 0.8, 0.25, 1),
    right 350ms cubic-bezier(0.25, 0.8, 0.25, 1) !important;
  will-change: width;
}

.suspended-toolbar--mini {
  width: calc(100% - 105px) !important;
  transition: width 350ms cubic-bezier(0.25, 0.8, 0.25, 1), left 350ms cubic-bezier(0.25, 0.8, 0.25, 1),
    right 350ms cubic-bezier(0.25, 0.8, 0.25, 1) !important;
}

.toolbar-shell {
  position: relative;
}

.toolbar-accent {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 20px;
  background-color: #fafafa;
  z-index: 3;
  pointer-events: none;
}

.logo-container {
  display: flex;
  align-items: center;
  width: 130px;
}

.logo-container img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

@media (max-width: 1260px) {
  .suspended-toolbar {
    left: 6px !important;
    right: 6px !important;
    width: calc(100% - 12px) !important;
  }

  .logo-container {
    width: 100px;
  }
}
</style>
